import { useClientQuery } from "web_myplann/Api/Client/useClientQuery";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { PersonalDataField } from "web_myplann/Profile/Types/PersonalDataField";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";

const R = Resources.PersonalDataAndAccounts.PersonalData;

export const usePersonalDataFields = () => {
	const { t } = useResource();
	const { data: userData, isLoading } = useClientQuery();
	const data = userData?.data;

	const fields: PersonalDataField[] = [
		{
			id: "name",
			label: t(R.Name),
			value: data?.firstName,
		},
		{
			id: "surname",
			label: t(R.Surname),
			value: data?.lastName,
		},
		{
			id: "birth-number",
			label: t(R.BirthNumber),
			value: data?.identificationNumber,
		},
		{
			id: "birth-date",
			label: t(R.BirthDate),
			value: dateFormatter(data?.bornDate),
		},
		{
			id: "birth-place",
			label: t(R.BirthPlace),
			value: data?.bornPlace,
		},
		{
			id: "marital-status",
			label: t(R.MaritalStatus),
			value: data?.maritalStatus,
		},
		{
			id: "health-insurance",
			label: t(R.HealthInsurance),
			value: data?.healthInsurance,
		},
	];

	return {
		clientNotFound: !isLoading && !data,
		fields,
		isLoading,
	};
};
